import { render, staticRenderFns } from "./configurationOrder.vue?vue&type=template&id=6e2e80bb&scoped=true"
import script from "./configurationOrder.vue?vue&type=script&lang=js"
export * from "./configurationOrder.vue?vue&type=script&lang=js"
import style0 from "./configurationOrder.vue?vue&type=style&index=0&id=6e2e80bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e80bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2e80bb')) {
      api.createRecord('6e2e80bb', component.options)
    } else {
      api.reload('6e2e80bb', component.options)
    }
    module.hot.accept("./configurationOrder.vue?vue&type=template&id=6e2e80bb&scoped=true", function () {
      api.rerender('6e2e80bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/configurationOrder.vue"
export default component.exports